import { calcUrl } from "@/features/ui/helpers/fetcher-helpers";
import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";
import useFetcher from "@/utils/use-fetcher";

export interface OrderRuleDraftParameter {
  lineSheetSetId: number;
}

export interface OrderRuleDraftRequest {}

export type OrderRuleDraftStatus =
  | "NONE" // 초안이 아직 만들어지지 않음
  | "PENDING" // 초안 있음, 사람이 아직 저장하지 않음
  | "ACCEPTED" // 초안 그대로 저장됨
  | "EDITED" // 사람이 고쳐서 저장 — 다음 초안의 교정 예시가 된다
  | "DISCARDED" // 초안을 버리고 빈 오더룰로 저장
  | "FAILED"; // 초안 생성 실패

export interface OrderRuleDraftResponse {
  lineSheetSetId: number;
  status: OrderRuleDraftStatus;
  draft?: string | null;
  /** 사람이 고쳐 저장한 내용 — 있으면 이 쪽이 현재 초안이다 */
  resolved?: string | null;
  /** 초안을 만들 때 읽은 원문 — 메일 본문 + 오더룰 첨부 추출 텍스트 */
  sourceText?: string | null;
  sourceKind?: "GMAIL" | "FILE" | "MIXED" | null;
  model?: string | null;
  /** 같은 부티크의 과거 사례를 몇 건 참고했는지 */
  shotCount: number;
  error?: string | null;
  createdAt?: Date | null;
}

export const orderRuleDraftTemplateUrl =
  "/line-sheet-sets/:lineSheetSetId/order-rule-draft";

export const getOrderRuleDraftKey: YWRKey<OrderRuleDraftParameter> = {
  url: (parameter) => calcUrl(orderRuleDraftTemplateUrl, parameter),
  method: "get",
};

export const generateOrderRuleDraftKey: YWRKey<OrderRuleDraftParameter> = {
  url: (parameter) => calcUrl(orderRuleDraftTemplateUrl, parameter),
  method: "post",
};

export function useGetOrderRuleDraft() {
  const fetcher = useFetcher<OrderRuleDraftRequest, OrderRuleDraftResponse>();
  return useYWR(getOrderRuleDraftKey, fetcher);
}

/** 원문을 다시 읽어 초안을 새로 만든다. 수 초~십수 초 걸린다. */
export function useGenerateOrderRuleDraft() {
  const fetcher = useFetcher<OrderRuleDraftRequest, OrderRuleDraftResponse>();
  return useYWR(generateOrderRuleDraftKey, fetcher);
}
